import React, { useContext, useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import CustomTypography from "../../globalStyles/fonts";
import CheckIcon from "@mui/icons-material/Check";
import styles from "./asn-tracking.module.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { asnService } from "../../utils/services/asnService";
import {
  getFormattedDate,
  formatDateTime,
  trailEventDate,
} from "../../utils/formatDate";
import AutocompleteWithPagination from "../../components/autocomplete-with-pagination";

export default function AsnTrackingHistory() {
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const dummyTrackingDetails = [
    {
      name: "Created",
      sl: 1,
      reached: false,
      subSteps: [],
      details: {
        text: "Asn is created.",
      },
    },
    {
      name: "Supplier Notified",
      sl: 2,
      reached: false,
      subSteps: [],
      details: {
        text: "Supplier is notified.",
      },
    },
    {
      name: "Supplier Confirmed",
      sl: 3,
      reached: false,
      subSteps: [],
      details: {
        text: "Supplier has confirmed.",
      },
    },
    {
      name: "Inventory Ready",
      sl: 4,
      reached: false,
      subSteps: [],
      details: {
        text: "Inventory is ready.",
      },
    },
    {
      name: "Pickup Scheduled",
      sl: 5,
      reached: false,
      subSteps: [],
      details: {
        text: "Pickup is scheduled.",
      },
    },
    {
      name: "Picked Up",
      sl: 6,
      reached: false,
      subSteps: [],
      details: {
        text: "Picked up.",
      },
    },
    {
      name: "Reached Warehouse",
      sl: 7,
      reached: false,
      subSteps: [],
      details: {
        text: "Reached at warehouse.",
      },
    },
    {
      name: "Stock-in Complete",
      sl: 8,
      reached: false,
      subSteps: [],
      details: {
        text: "Warehouse have received the shipment and inventory is updated.",
      },
    },
  ];

  const [trackData, setTrackData] = useState(dummyTrackingDetails);
  const [asnList, setASNList] = useState([]);
  const [asnTrackData, setAsnTrackData] = useState([]);
  const [asnData, setAsnData] = useState({});
  const [activeStep, setActiveStep] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedASN, setSelectedASN] = useState(null);
  const [selectedSku, setSelectedSku] = useState(null);
  const handleSelect = (event, value) => {
    if (value) {
      setSelectedASN(value);
    }
  };
  const location = useLocation();
  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  const setTrackingData = () => {
    let allTrackingStatus = asnTrackData.map((x) => x.status);
    setTrackData(
      dummyTrackingDetails.map((item) => ({
        ...item,
        reached: allTrackingStatus?.includes(item.name) ? true : false,
        date: asnTrackData?.find((x) => x.status === item.name)?.parent?.date,
        createdAt: asnTrackData?.find((x) => x.status === item.name)?.parent
          ?.createdAt,
        details:
          asnTrackData?.find((x) => x.status === item.name)?.parent ||
          item.details,
        subSteps: asnTrackData?.find((x) => x.status === item.name)?.values,
      })),
    );
  };

  const fetchTrackingData = async (id) => {
    try {
      const response = await asnService.fetchAsnTrail(id);
      setAsnTrackData(response);
      const resp = await asnService.fetchById(id);
      setAsnData(resp);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const fetchASNListAndTrackingData = async (sku) => {
    try {
      let asn_list = await asnService.fetchASNBySku(sku);
      setASNList(asn_list.data);
      fetchTrackingData(asn_list.data[0]._id);
      setSelectedASN(asn_list.data[0]);
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  useEffect(() => {
    let path = location.pathname.split("/");
    if (location.search.includes("inventory")) {
      setSelectedSku(decodeURIComponent(path[path.length - 1]));
      fetchASNListAndTrackingData(decodeURIComponent(path[path.length - 1]));
    } else {
      fetchTrackingData(path[path.length - 1]);
    }
  }, [location]);
  useEffect(() => {
    if (asnTrackData.length) {
      setTrackingData();
    }
  }, [asnTrackData]);
  function getLastReachedStep(trackingDetails) {
    return trackingDetails.reduce((lastReached, currentStep) => {
      return currentStep.reached ? currentStep : lastReached;
    }, null);
  }

  return (
    <div
      className="scrollableDiv"
      style={{
        display: "flex",
        justifyContent: "center",
        overflowY: "scroll",
        width: "100%",
        height: "100%",
        position: "relative",
        scrollbarWidth: "none", // For Firefox
        msOverflowStyle: "none",
        padding: 20, // F
      }}
    >
      <div className={styles.container}>
        {/* Vertical line */}

        <div
          className={styles.leftContainer}
          style={{
            marginLeft: "30px",
            padding: 15,
            maxHeight: currentUser?._id ? "98%" : "92%",
            display: "flex",
            flexDirection: "column",
            borderWidth: 2,
            borderRadius: 8,
            backgroundColor: "var(--bg-paper)",
            width: "95%",
          }}
        >
          <header className={styles.trackingHeader}>
            <h1 className={styles.trackingNumber}>
              P.O. No : {asnData?.asn_no}
              <span style={{ fontSize: 17 }}>{}</span>
            </h1>
          </header>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
            className={styles.statusBadge}
          >
            <div
              // className={styles.badgeContent}
              style={{
                minWidth: 200,
                fontSize: 15,
                backgroundColor: "rgba(15, 254, 91, 0.171)",
                borderRadius: 10,
                border: "1px solid rgba(13, 255, 0, 0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {getLastReachedStep(trackData)?.name}
            </div>
            {selectedSku ? (
              <div
                style={{
                  minWidth: 200,
                }}
              >
                <AutocompleteWithPagination
                  selectedItem={selectedASN}
                  onDataChange={(e) => {
                    if (e) {
                      fetchTrackingData(e?._id);
                      setSelectedASN(e);
                    }
                  }}
                  hideLabel
                  width={"100%"}
                  optionKey={"asn_no"}
                  apiEndPoint={(limit, skip, search) => {
                    return asnService.fetchASNBySku(
                      selectedSku,
                      skip,
                      limit,
                      search,
                    );
                  }}
                ></AutocompleteWithPagination>
              </div>
            ) : (
              <></>
            )}
          </div>
          <section className={styles.orderInfo}>
            <div className={styles.orderDetails}>
              <div className={styles.orderDateWrapper}>
                <span className={styles.orderDateLabel}>Date:</span>
                <time className={styles.orderDate}>
                  {new Date(asnData?.createdAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </time>
              </div>
              <div className={styles.separator} />
              <div className={styles.estimatedDelivery}>
                <img src="/truck-tick.png" alt="" className={styles.icon} />
                <span
                  className={styles.estimatedDeliveryText}
                >{`Expected delivery: `}</span>
                {asnData?.expected_dispatch_date ? (
                  <time className={styles.orderDate}>
                    {new Date(
                      asnData.expected_dispatch_date,
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </time>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </section>
          <div
            style={{
              width: "100%",
              marginTop: 30,
              maxHeight: "99%",
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
            }}
          >
            {trackData?.map((step, index) => {
              const lastReached = trackData
                .slice()
                .reverse()
                .find((data) => data.reached === true);
              return (
                <div
                  onClick={() => handleStepClick(index)}
                  key={step.sl}
                  style={{
                    marginBottom: "10px",
                    cursor: "pointer",
                    position: "relative",
                    backgroundColor: index === activeStep ? "#E4FFE8" : "",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor:
                          step.reached || step?.sl < lastReached?.sl
                            ? "green"
                            : "white",
                        marginRight: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderWidth: 1,
                        border:
                          !step.reached || !step?.sl < lastReached?.sl
                            ? "1px solid #D9D9D9"
                            : "",
                        marginBottom: 5,
                      }}
                    >
                      {(step.reached || step?.sl < lastReached?.sl) && (
                        <CheckIcon
                          style={{ color: "#fff", fontSize: "16px" }}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        flexDirection: "column",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 14,
                          color:
                            step.reached || step?.sl < lastReached?.sl
                              ? "#06B217"
                              : "var(--text-tertiary)",
                          fontWeight: "600",
                        }}
                      >
                        {step?.name}
                      </span>
                      <span
                        style={{
                          fontSize: 14,
                          color: "var(--text-tertiary)",
                          fontWeight: "500",
                        }}
                      >
                        {step?.createdAt
                          ? `${getFormattedDate(step?.createdAt).dateStr} ${
                              getFormattedDate(step?.createdAt).time
                            }`
                          : trackData.find(
                                (data, i) => i >= index && data?.createdAt,
                              )
                            ? `${
                                getFormattedDate(
                                  trackData.find(
                                    (data, i) => i >= index && data?.createdAt,
                                  )?.createdAt,
                                ).dateStr
                              } ${
                                getFormattedDate(
                                  trackData.find(
                                    (data, i) => i >= index && data?.createdAt,
                                  )?.createdAt,
                                ).time
                              }`
                            : ""}
                      </span>
                    </div>
                  </div>

                  <div style={{ display: "flex" }}>
                    {index === trackData?.length - 1 ? (
                      <></>
                    ) : (
                      <div
                        style={{
                          minHeight: 50,
                          height: "calc(100% - 24px)", // Subtract the height of the circle
                          marginLeft: 12,
                          marginTop: 5,
                          borderLeft: step.reached
                            ? "1px dotted #06B217"
                            : "1px dotted #757477",
                          width: 2,
                          position: "absolute",
                          top: 24, // Start from the bottom of the circle
                        }}
                      ></div>
                    )}
                    <div
                      style={{
                        paddingLeft: "20px",
                        textAlign: "left",
                        // maxHeight: '100px',
                        overflowY: "auto",
                        marginTop: "8px",
                      }}
                    >
                      {step.details && step?.subSteps?.length ? (
                        <>
                          <CustomTypography
                            style={{ fontSize: 10 }}
                            variant="body2"
                          >
                            {step?.subSteps[0]?.message}
                          </CustomTypography>
                          {/* <CustomTypography style={{ marginTop: 1, fontSize: 10 }} variant="caption">
                            {step?.subSteps?.length
                              ? formatDateTime(step?.subSteps[0]?.createdAt)
                              : ''}
                          </CustomTypography> */}
                        </>
                      ) : (
                        <></>
                      )}
                      {step.subSteps?.length > 0 ? (
                        step.subSteps
                          ?.sort(
                            (a, b) =>
                              new Date(a.createdAt) - new Date(b.createdAt),
                          )
                          ?.map((step, subIndex) => (
                            <div
                              key={`${index}-${subIndex}`}
                              style={{
                                marginBottom: "5px",
                                position: "relative",
                                marginTop: 10,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    marginRight: "8px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderWidth: 1,
                                    border: !step.reached
                                      ? "1px solid #D9D9D9"
                                      : "",
                                  }}
                                >
                                  <div
                                    style={{
                                      height: 12,
                                      width: 12,
                                      borderRadius: 50,
                                      backgroundColor: "#06B217",
                                    }}
                                  ></div>
                                </div>
                                <span
                                  style={{
                                    fontSize: 12,
                                    color: step.reached
                                      ? "#06B217"
                                      : "var(--text-tertiary)",
                                    fontWeight: "600",
                                  }}
                                >
                                  {step.description}
                                </span>
                              </div>

                              <div style={{ display: "flex" }}>
                                {trackData[index]?.subSteps?.length > 1 &&
                                subIndex !==
                                  trackData[index]?.subSteps?.length - 1 ? (
                                  <div
                                    style={{
                                      marginLeft: 12,
                                      marginTop: 5,
                                      borderLeft: "1px dotted #06B217",
                                      width: 2,
                                    }}
                                  ></div>
                                ) : (
                                  <div style={{ marginLeft: 14 }} /> // Maintain spacing without line
                                )}
                                <div
                                  style={{
                                    paddingLeft: "20px",
                                    textAlign: "left",
                                    maxHeight: "100px",
                                    overflowY: "auto",
                                    marginTop: "5px",
                                    marginLeft: 3,
                                  }}
                                >
                                  <CustomTypography
                                    style={{
                                      fontSize: 13,
                                      marginBottom: "3px",
                                    }}
                                    variant="body2"
                                  >
                                    {step?.location || ""}
                                  </CustomTypography>
                                  <CustomTypography
                                    style={{ fontSize: 10, marginTop: "5px" }}
                                    variant="body2"
                                  >
                                    {formatDateTime(trailEventDate(step))}
                                  </CustomTypography>
                                </div>
                              </div>
                            </div>
                          ))
                      ) : step?.sl < lastReached?.sl ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              marginRight: "8px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderWidth: 1,
                              border:
                                !step.reached || !step?.sl < lastReached?.sl
                                  ? "1px solid #D9D9D9"
                                  : "",
                            }}
                          >
                            <div
                              style={{
                                height: 12,
                                width: 12,
                                borderRadius: 50,
                                backgroundColor: "#06B217",
                              }}
                            ></div>
                          </div>
                          <div
                            style={{
                              flexDirection: "column",
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "start",
                            }}
                          >
                            <span
                              style={{
                                fontSize: 12,
                                color: "var(--text-tertiary)",
                                fontWeight: "600",
                                marginTop: 17,
                              }}
                            >
                              {step?.sl < lastReached?.sl
                                ? step.details?.text
                                : ""}
                            </span>
                            <span
                              style={{
                                fontSize: 14,
                                color: "var(--text-tertiary)",
                                fontWeight: "500",
                                fontSize: 10,
                                marginTop: 5,
                              }}
                            >
                              {step?.createdAt
                                ? `${
                                    getFormattedDate(step?.createdAt).dateStr
                                  } ${getFormattedDate(step?.createdAt).time}`
                                : trackData.find(
                                      (data, i) =>
                                        i >= index && data?.createdAt,
                                    )
                                  ? `${
                                      getFormattedDate(
                                        trackData.find(
                                          (data, i) =>
                                            i >= index && data?.createdAt,
                                        )?.createdAt,
                                      ).dateStr
                                    } ${
                                      getFormattedDate(
                                        trackData.find(
                                          (data, i) =>
                                            i >= index && data?.createdAt,
                                        )?.createdAt,
                                      ).time
                                    }`
                                  : ""}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {drawerOpen ? (
          <div
            className={styles.rightContainer}
            style={{
              marginLeft: 10,
              borderWidth: 2,
              borderRadius: 8,
              display: "flex",
              overflow: "auto",
              flexDirection: "column",
              maxHeight: "95%",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: currentUser?._id ? 10 : 0,
                right: 20,
                cursor: "pointer",
              }}
              onClick={handleDrawerClose}
            >
              <CloseIcon></CloseIcon>
            </div>
            {activeStep !== null && (
              <div style={{ padding: "20px" }}>
                <div
                  style={{ display: "flex", alignItems: "center", padding: 20 }}
                >
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor: trackData[activeStep].reached
                        ? "green"
                        : "white",
                      marginRight: "8px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderWidth: 1,
                      border: !trackData[activeStep].reached
                        ? "1px solid #D9D9D9"
                        : "",
                    }}
                  >
                    {trackData[activeStep].reached && (
                      <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
                    )}
                  </div>
                  <span
                    style={{
                      color: trackData[activeStep].reached
                        ? "#06B217"
                        : "var(--text-tertiary)",
                      fontWeight: "600",
                    }}
                  >
                    {trackData[activeStep]?.name}
                  </span>
                </div>
                {/* <h6>{trackData[activeStep].name} - Details</h6> */}
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
        {drawerOpen ? (
          <Dialog
            className={styles.showForMobile}
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              Tracking Details
              <IconButton
                aria-label="close"
                onClick={() => setDrawerOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {activeStep !== null && (
                <div
                  style={{
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                    maxHeight: 500,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: 20,
                    }}
                  >
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: trackData[activeStep].reached
                          ? "green"
                          : "white",
                        marginRight: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderWidth: 1,
                        border: !trackData[activeStep].reached
                          ? "1px solid #D9D9D9"
                          : "",
                      }}
                    >
                      {trackData[activeStep].reached && (
                        <CheckIcon
                          style={{ color: "#fff", fontSize: "16px" }}
                        />
                      )}
                    </div>
                    <span
                      style={{
                        color: trackData[activeStep].reached
                          ? "#06B217"
                          : "var(--text-tertiary)",
                        fontWeight: "600",
                      }}
                    >
                      {trackData[activeStep]?.name}
                    </span>
                  </div>
                  {trackData[activeStep].subSteps?.length > 0 ? (
                    trackData[activeStep].subSteps?.map((step, index) => (
                      <div
                        key={`${activeStep}-${index}`}
                        style={{
                          marginBottom: "5px",
                          position: "relative",
                          marginLeft: 40,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              marginRight: "8px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderWidth: 1,
                              border: !step.reached ? "1px solid #D9D9D9" : "",
                            }}
                          >
                            <div
                              style={{
                                height: 12,
                                width: 12,
                                borderRadius: 50,
                                backgroundColor: "#06B217",
                              }}
                            ></div>
                          </div>
                          <span
                            style={{
                              color: step.reached
                                ? "#06B217"
                                : "var(--text-tertiary)",
                              fontWeight: "600",
                            }}
                          >
                            {step.order_number}
                          </span>
                        </div>
                        <div style={{ display: "flex" }}>
                          {index ===
                          trackData[activeStep].subSteps?.length - 1 ? (
                            <></>
                          ) : (
                            <div
                              style={{
                                height: 50,
                                marginLeft: 12,
                                marginTop: 5,
                                borderLeft: "1px dotted #06B217",
                                width: 2,
                              }}
                            ></div>
                          )}
                          <div
                            style={{
                              paddingLeft: "20px",
                              textAlign: "left",
                              maxHeight: "100px",
                              overflowY: "auto",
                              marginTop: "8px",
                            }}
                          >
                            <CustomTypography
                              style={{ fontSize: 10 }}
                              variant="body2"
                            >
                              {formatDateTime(trailEventDate(step))}
                            </CustomTypography>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No substeps available</p>
                  )}
                </div>
              )}
            </DialogContent>
          </Dialog>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
